import { useQuery } from "@tanstack/react-query";

import { get } from "common/helpers/HTTP";
import type { Pricing } from "common/types";

async function getPricingRequest(): Promise<Pricing[]> {
  return (await get("billing/pricing")).pricing;
}

export default function useAllPricing() {
  const { data: allPricing, isLoading: isLoadingAllPricing } = useQuery({
    queryKey: ["allPricing"],
    queryFn: getPricingRequest,
    refetchOnMount: false,
  });

  return { allPricing, isLoadingAllPricing };
}
